module.exports = __webpack_public_path__ + "static/media/Mountain_pines_Uttarakhand_cred_Alamy.8f79802d.jpg";